export default `
	headline
	paragraph {
		content
	}
	linkedButton {
		...on LinkedButtonItem {
			disabled
			heading
			linkUrl
			target
		}
	}
`;
